import React from "react"
import Link from "next/link"
import { Container, Row, Col } from "react-bootstrap"
import { useUser } from "@auth0/nextjs-auth0/client"
import { Check, ChevronRight } from "lucide-react"

const BottomBlock = (props) => {
  const { user } = useUser()
  const isUserLoggedIn = !!user

  return (
    <section className="py-5">
      <Container>
        <div className="cta-card">
          {/* Plus-grid background overlay pattern (Opacity masked) */}
          <div className="cta-plus-pattern">
            <svg width="100%" height="100%">
              <defs>
                <pattern id="plus-pattern-bottom" x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse">
                  <line x1="8" y1="5" x2="8" y2="11" stroke="#ffffff" strokeWidth="1" />
                  <line x1="5" y1="8" x2="11" y2="8" stroke="#ffffff" strokeWidth="1" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#plus-pattern-bottom)" />
            </svg>
          </div>

          <Row className="g-5 align-items-center position-relative" style={{ zIndex: 10 }}>
            {!isUserLoggedIn ? (
              /* ==========================================
                 CASE 1: ANONYMOUS USER (NOT LOGGED IN)
                 ========================================== */
              <>
                <Col lg="6" className="cta-left-col">
                  <h2 className="cta-title">Join Vendorland</h2>
                  <p className="cta-subtitle">
                    Get discovered by businesses looking for trusted technology partners.
                  </p>
                  <p className="cta-description">
                    Create your company profile, collect verified reviews, and increase your visibility.
                  </p>
                  <Link href={props.bottomBlock.buttonLink || "/auth/login"} passHref legacyBehavior>
                    <a className="cta-btn">
                      Get Listed
                      <ChevronRight style={{ width: "16px", height: "16px" }} />
                    </a>
                  </Link>
                </Col>

                <Col lg="6" className="cta-right-col">
                  <h3 className="cta-right-title">Why join?</h3>
                  <ul className="cta-list">
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Create a free company profile
                    </li>
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Collect verified client reviews
                    </li>
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Increase your online presence
                    </li>
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Get discovered by potential clients
                    </li>
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Stand out with a Sponsored Listing
                    </li>
                  </ul>
                </Col>
              </>
            ) : (
              /* ==========================================
                 CASE 2: LOGGED IN USER
                 ========================================== */
              <>
                <Col lg="6" className="cta-left-col">
                  <h2 className="cta-title">Need assistance?</h2>
                  <p className="cta-subtitle">
                    Whether you have questions about your account, company profile, reviews, or Vendorland, our team is here to help.
                  </p>
                  <p className="cta-description" style={{ marginBottom: "1.5rem" }}></p>
                  <Link href={props.bottomBlock.buttonLink || "/contact"} passHref legacyBehavior>
                    <a className="cta-btn">
                      Contact us
                      <ChevronRight style={{ width: "16px", height: "16px" }} />
                    </a>
                  </Link>
                </Col>

                <Col lg="6" className="cta-right-col">
                  <h3 className="cta-right-title">Questions?</h3>
                  <p className="cta-right-subtitle">We're here to help.</p>
                  <ul className="cta-list">
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Account support
                    </li>
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Company profile assistance
                    </li>
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Review assistance
                    </li>
                    <li className="cta-list-item">
                      <Check className="cta-check-icon" />
                      Sponsored listings
                    </li>
                  </ul>
                </Col>
              </>
            )}
          </Row>
        </div>
      </Container>
    </section>
  )
}

export default BottomBlock
